import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form__field" }
const _hoisted_2 = { class: "form__input d-flex" }
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addKeyword && _ctx.addKeyword(...args)), ["stop","prevent"]), ["enter"])),
          name: "keyword",
          id: "keyword",
          type: "text"
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelText, _ctx.keyword]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "button button--small button--ghost",
          style: {"margin-left":"10px"},
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addKeyword && _ctx.addKeyword(...args)))
        }, " Add ")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentKeywords, (keyword) => {
        return (_openBlock(), _createElementBlock("span", {
          key: keyword,
          class: "keyword-list"
        }, [
          _createTextVNode(_toDisplayString(keyword) + " ", 1 /* TEXT */),
          _createElementVNode("span", {
            onClick: _withModifiers(($event: any) => (_ctx.removeKeyword(keyword)), ["prevent","stop"]),
            class: "keyword-list__close"
          }, "x", 8 /* PROPS */, _hoisted_4)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}